// extracted by mini-css-extract-plugin
export default {"ratingBlock":"Rating_ratingBlock__TEX3o","iconStar":"Rating_iconStar__Z-hP-"};